import EMAIL_TEMPLATES from "$types/EMAIL_TEMPLATES"
import {
  pgTable,
  serial,
  timestamp,
  varchar,
  integer,
  boolean,
} from "drizzle-orm/pg-core"
import { eventsTable } from "./Events"
import { relations } from "drizzle-orm"

export const eventsEmailsTable = pgTable("EventsEmails", {
  id: serial().primaryKey(),
  template: varchar().notNull().$type<EMAIL_TEMPLATES>(),
  title: varchar().notNull(),
  content: varchar().notNull().default(""),
  subject: varchar().notNull().default(""),
  timestamp: timestamp({ withTimezone: true }),
  afterRegistration: boolean().notNull().default(false),
  eventId: integer().notNull().references(() => eventsTable.id, { onDelete: "cascade" }),
})

export const eventsEmailsTableRelations = relations(
  eventsEmailsTable,
  ({ one }) => ({
    event: one(eventsTable, {
      fields: [eventsEmailsTable.eventId],
      references: [eventsTable.id],
    }),
  }),
)

export type EventEmailSchema = typeof eventsEmailsTable.$inferSelect
export type NewEventEmailSchema = typeof eventsEmailsTable.$inferInsert
